<aside id="sidebar" class="sidebar break-point-lg has-bg-image">
  <a id="btn-collapse" class="sidebar-collapser">
    <i class="fa-solid fa-angle-right"></i>
  </a>
  <div class="sidebar-layout">
    <div class="sidebar-header">
      <div class="small-logo cursor-pointer" routerLink="/dashboard" routerLinkActive="active">
        <img src="../../../assets/images/small-logo.svg" alt="">
      </div>
      <div class="pro-sidebar-logo cursor-pointer" routerLink="/dashboard" routerLinkActive="active">
        <img src="../../../assets/images/sidebar-logo.svg" alt="">
      </div>
    </div>
    <div class="sidebar-content">
      <nav class="menu open-current-submenu" id="myNav">
        <!-- Menus, order and visibility come from the signed-in role's permissions -->
        <ul>
          <ng-container *ngFor="let item of menuTree()">
            <!-- Parent menu with children -->
            <li *ngIf="item.isParent" class="menu-item sub-menu" [class.open]="activeSubmenu === item.menuKey">
              <a href="javascript:void(0)" (click)="toggleSubMenu(item.menuKey)">
                <span class="menu-icon"><img [src]="item.icon"></span>
                <span class="menu-title">{{ item.menuName }}</span>
                <span class="arrow-icon" [class.rotate]="activeSubmenu === item.menuKey"></span>
              </a>
              <div class="sub-menu-list">
                <ul *ngIf="activeSubmenu === item.menuKey">
                  <li class="menu-item" *ngFor="let child of item.children">
                    <a *ngIf="child.route === '/app-user'; else defaultChildLink"
                       [routerLink]="child.route"
                       [class.active]="isAppUsersActive()">
                      <span class="menu-icon"><img [src]="child.icon"></span>
                      <span class="menu-title">{{ child.menuName }}</span>
                    </a>
                    <ng-template #defaultChildLink>
                      <a [routerLink]="child.route" routerLinkActive="active"
                         [routerLinkActiveOptions]="{ exact: isExactRoute(child) }">
                        <span class="menu-icon"><img [src]="child.icon"></span>
                        <span class="menu-title">{{ child.menuName }}</span>
                      </a>
                    </ng-template>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Standalone menu -->
            <li *ngIf="!item.isParent" class="menu-item">
              <a [routerLink]="item.route" routerLinkActive="active">
                <span class="menu-icon"><img [src]="item.icon"></span>
                <span class="menu-title">{{ item.menuName }}</span>
              </a>
            </li>
          </ng-container>
        </ul>
      </nav>
    </div>
  </div>
</aside>
<div id="overlay" class="overlay"></div>
